var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle4, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManWithGraphsYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 727.893 637.36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M44.026 0a2.73 2.73 0 0 0-2.727 2.727v93.012a2.73 2.73 0 0 0 2.727 2.727h317.156a2.73 2.73 0 0 0 2.727-2.727V2.727A2.73 2.73 0 0 0 361.182 0Z",
  "data-name": "fc914514-1042-4f3e-9382-2a2bd3a05a2f"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.132 91.633h308.942v-84.8H48.132Z",
  "data-name": "fc60a940-5b5f-47e1-886f-8b9349204f05"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M318.078 74.04a4.518 4.518 0 1 0 0 9.035h18.069a4.518 4.518 0 1 0 0-9.035Z",
  "data-name": "b37dca77-34e7-4938-924b-74ea49a8e34b"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M132.077 65.278h208.588v1.189H132.077z",
  "data-name": "a114a1b8-363a-4115-bcea-0275bda15cb1"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 88.476,
  cy: 49.233,
  r: 26.311,
  fill: "#e6e6e6",
  "data-name": "fd059875-cd6f-429e-81eb-c199f1a3d666"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m132.409 58.641-.659-.989 21.675-14.45 14.863 7.135 21.379-13.659.289.123 42.24 18.019 33.867-16.637 32.887 13.333 41.323 8.4.788.89-41.875-7.911-33.077-13.411-33.88 16.642-42.452-18.109-21.408 13.677-14.85-7.128Z",
  "data-name": "ad693766-5e26-437f-8d3d-58ce33ee9e84"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M135.94 74.663a3.863 3.863 0 0 0 0 7.725h40.41a3.863 3.863 0 0 0 .124-7.725h-.124Z",
  "data-name": "ff424c2d-4733-4249-9b35-4eb43ebe2556"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M99.06 48.906a1.58 1.58 0 0 0-2.232 0l-6.774 6.774V38.976a1.578 1.578 0 0 0-3.156 0V55.68l-6.774-6.774a1.578 1.578 0 0 0-2.237 2.226l.006.006 9.467 9.467a1.58 1.58 0 0 0 2.232 0l9.467-9.467a1.58 1.58 0 0 0 0-2.232"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M168.801 148.963a2.73 2.73 0 0 0-2.727 2.727v93.012a2.73 2.73 0 0 0 2.727 2.727h317.157a2.73 2.73 0 0 0 2.727-2.727V151.69a2.73 2.73 0 0 0-2.727-2.727Z",
  "data-name": "ebf544e0-cedc-491d-9ace-ce79788cc3b4"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M172.908 240.596h308.943v-84.8H172.908Z",
  "data-name": "f05ecdaf-6a8f-49c4-b8a7-f7e5ce9efcf7"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M442.854 223.005a4.518 4.518 0 1 0 0 9.035h18.067a4.518 4.518 0 1 0 0-9.035z",
  "data-name": "a9f7bc9d-00a6-4157-bba1-ffc7ec111a68"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M256.853 214.242h208.588v1.189H256.853z",
  "data-name": "a15d3d52-efbb-4636-8d15-228635c5d6e5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 213.251,
  cy: 198.197,
  r: 26.311,
  fill: "#ffbd01",
  "data-name": "e4ee77d8-efe6-4a2a-a3ed-71b8f3ee957e"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m257.183 207.605-.66-.989 21.675-14.45 14.864 7.135 21.379-13.659.289.123 42.239 18.019 33.868-16.637 32.887 13.332 41.323-36.6.788.89-41.875 37.086-33.077-13.41-33.88 16.642-42.451-18.109-21.408 13.677-14.846-7.125Z",
  "data-name": "fc1c89ac-2b6e-4831-b128-0ac2ab1fa850"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M260.716 223.626a3.863 3.863 0 1 0-.126 7.725h40.536a3.863 3.863 0 0 0 0-7.725Z",
  "data-name": "bd690ac4-3df0-4871-95d5-adaa934b7c24"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M202.668 198.524a1.58 1.58 0 0 0 2.231 0l6.774-6.774v16.704a1.578 1.578 0 1 0 3.156 0V191.75l6.774 6.774a1.578 1.578 0 1 0 2.231-2.232l-9.467-9.467a1.58 1.58 0 0 0-2.232 0l-9.467 9.467a1.58 1.58 0 0 0 0 2.232"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M2.727 297.927A2.73 2.73 0 0 0 0 300.654v93.012a2.73 2.73 0 0 0 2.727 2.727h317.156a2.73 2.73 0 0 0 2.727-2.727v-93.012a2.73 2.73 0 0 0-2.727-2.727Z",
  "data-name": "b1a491a7-739b-4f1f-bff8-dbf70f6892c8"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.834 389.56h308.943v-84.8H6.834Z",
  "data-name": "acd48b1a-d10a-4276-b388-f016adebff0c"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M276.779 371.968a4.518 4.518 0 0 0 0 9.035h18.069a4.518 4.518 0 1 0 0-9.035Z",
  "data-name": "bed21912-b6c9-41df-a59b-963435bac71a"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M90.778 363.206h208.588v1.189H90.778z",
  "data-name": "a26455fb-834b-4368-afb2-80d86a75d46a"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.177,
  cy: 347.16,
  r: 26.311,
  fill: "#ffbd01",
  "data-name": "f17c58cd-37a1-42e1-9e5f-26c2ec8825b4"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m91.108 356.569-.659-.989 21.675-14.451 14.863 7.135 21.38-13.663 42.528 18.141 33.867-16.637 32.883 13.337 41.323-16.6.788.89-41.87 17.089-33.077-13.41-33.879 16.642-42.452-18.11-21.407 13.679-14.85-7.128Z",
  "data-name": "b803193f-4714-40c6-8606-08b9dea6d22d"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M94.641 372.589a3.863 3.863 0 0 0 0 7.725h40.41a3.863 3.863 0 1 0 .126-7.725h-.126Z",
  "data-name": "b19b31b4-3a52-4fc9-8ed4-dc6729deb0ed"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.594 347.487a1.58 1.58 0 0 0 2.231 0l6.774-6.774v16.704a1.578 1.578 0 0 0 3.156.01v-16.714l6.774 6.774a1.578 1.578 0 0 0 2.237-2.226l-.006-.006-9.467-9.467a1.58 1.58 0 0 0-2.232 0l-9.467 9.467a1.58 1.58 0 0 0 0 2.232"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb7b7",
  d: "m650.421 621.963-15.229-.001-7.244-58.737 22.475.001z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m654.304 636.725-49.102-.002v-.621a19.113 19.113 0 0 1 19.112-19.112h.001l29.99.001Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb7b7",
  d: "m594.525 621.963-15.228-.001-7.245-58.737 22.476.001z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m598.409 636.725-49.103-.002v-.621a19.113 19.113 0 0 1 19.112-19.112h.002l29.99.001Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb7b7",
  d: "M565.823 431.446a11.647 11.647 0 0 0 .22-17.859l8.277-25.296-14.146-8.78-11.187 35.888a11.71 11.71 0 0 0 16.836 16.047"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M580.913 414.746s-14.214 76.942-14.037 91.876c.214 18.023 8.233 95.264 8.233 95.264l20.417-5.105 3.86-89.526 16.147-57.138 6.21 73.286 6.235 77.09h23.685l5.306-193.403-77.333-2.552Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#cbcbcb",
  d: "m651.734 259.705-40.834 1.276-25.521 158.231s54.232 24.884 77.201 7.019-10.846-166.526-10.846-166.526"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M616.642 293.52 582.19 491.31l-21.693-6.38 15.312-71.46 7.657-71.459-1.276-71.46 26.797-11.484 7.656-8.932s15.313 19.14 0 43.386M634.507 288.693l2.552 207.721 52.318-8.932-3.828-192.685L690.653 268l-25.52-11.485-10.335-6.38s-22.843 6.933-20.291 38.558"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m593.673 274.38-11.484-3.828-16.589 74.011-14.037 58.699 20.417 3.828 19.141-63.803z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb7b7",
  d: "M708.717 443.867a11.647 11.647 0 0 1-.22-17.858l-8.277-25.297 14.146-8.78 11.187 35.889a11.71 11.71 0 0 1-16.836 16.046"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m679.625 271.896 11.484-3.828 16.589 74.011 15.279 73.604-22.98 3.381-17.82-78.261z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 870.173,
  cy: 346.132,
  r: 28.362,
  fill: "#ffb7b7",
  transform: "rotate(-28.663 495.144 742.444)"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#cbcbcb",
  d: "M704.814 637.36h-230a1 1 0 0 1 0-2h230a1 1 0 0 1 0 2"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M624.23 177.699c27.113-7.82 34.81 14.653 34.81 14.653 13.068 8.67 4.886 19.542 4.886 19.542 3.298.732-3.296 20.03-5.495 19.542-1.173-.26-4.19 3.34-6.748 6.755a13.5 13.5 0 0 0-2.614.251l4.964-18.365s-16.732-2.563-21.862-10.624c-4.909-7.711-21.067-10.146-25.665-4.995a11.6 11.6 0 0 0-1.64-4.164 8.3 8.3 0 0 0-2.41-2.417c4.065-17.278 21.773-20.178 21.773-20.178"
})));
export default SvgManWithGraphsYellowIcon;